import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { classNames as cx } from "primereact/utils";

import notFoundLogo from "../../assets/not_found_logo.svg";
import forbiddenLogo from "../../assets/forbidden_logo.svg";

import classes from "./ErrorPage.module.scss";

export enum ErrorPageType {
  NotFound,
  Forbidden,
}

const dataMap = {
  [ErrorPageType.Forbidden]: {
    error: "Error 403: Forbidden.",
    info: "You do not have permission to access the requested resource.",
    logo: forbiddenLogo,
  },
  [ErrorPageType.NotFound]: {
    error: "404 Error",
    info: "The page you are looking for cannot be found.",
    logo: notFoundLogo,
  },
};

interface IErrorPageProps {
  type: ErrorPageType;
}

export function ErrorPage({ type }: IErrorPageProps) {
  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      <h1 className={classes.header}>{dataMap[type].error}</h1>
      <p className={classes.info}>{dataMap[type].info}</p>
      <img className={classes.logo} src={dataMap[type].logo} alt="not-found" />
      <Button
        label="GO BACK"
        type="reset"
        className={cx("p-button-outlined p-button-secondary", classes.button)}
        onClick={() => navigate(-1)}
      />
    </div>
  );
}
